<template>
  <div>
    <h1
      v-if="displayJobs.length"
      class="md:mx-1 font-bold text-center text-onyx text-21 leading-1-19 mb-l md:mb-m w-full"
    >
      {{ msg[0] }}
    </h1>
    <div
      class="mb-4 cursor-pointer"
      v-for="(job, index) in displayJobs"
      :key="index"
    >
    <a :href="generateLink(job)" :target="generateTarget(job)" class="one">
      <div class="listing-card border-2 border-solid border-transparent">
        <div class="w-auto md:w-738px lg:w-1023px">
          <div
            class="flex p-6 rounded-8 w-auto md:w-738px lg:w-1024px md:max-w-738"
          >
            <div class="hidden md:flex w-16 h-16">
              <img
                class="flex object-contain w-full h-full rounded-md border border-solid border-chrome-lightest"
                :src="job['company']['logo']"
                :alt="job['company']['name'] + ' Logo'"
                :title="job['company']['name'] + ' Logo'"
              />
            </div>
            <div class="flex flex-col md:ml-8 flex-1">
              <div class="flex md:hidden w-16 h-16 mb-4">
                <img
                  class="flex object-contain w-full h-full rounded-md border border-solid border-chrome-lightest"
                  :src="job['company']['logo']"
                  :alt="job['company']['name'] + ' Logo'"
                  :title="job['company']['name'] + ' Logo'"
                />
              </div>

              <div class="w-full flex justify-between md:mt-xs">
                <div
                  class="text-18 text-primary-darker font-medium leading-normal m-0 p-0 hover:underline cursor-pointer ellipse-two-lines line-height-normal"
                >
                  {{ job['title'] }}
                </div>

                <span class="hidden md:block">
                  <vs-chip
                    v-if="job['is_featured']"
                    color="rgba(124, 195, 102, 0.2)"
                    class="self-start"
                  >
                    <span
                      class="m-0 p-0 text-12 text-onyx font-bold w-auto text-center"
                      >Hiring Now</span
                    >
                  </vs-chip>
                </span>
              </div>

              <div class="p-0 m-0 text-14 text-onyx-lightest font-semibold">
                {{ job['company']['name'] }}
              </div>

              <div
                class="text-onyx-lightest font-normal mt-8px w-full flex items-center"
              >
                <div class="h-22px w-22px flex justify-center items-center">
                  <vs-icon
                    class="text-lg"
                    :class="icon.bold"
                    :icon="icon.type"
                    icon-pack="feather"
                  ></vs-icon>
                </div>

                <p class="ml-6px text-14 text-onyx-lightest">
                  {{ job['category'] }}
                </p>
              </div>

              <span class="md:hidden mt-16px">
                <vs-chip
                  v-if="job['is_featured']"
                  color="rgba(124, 195, 102, 0.2)"
                  class="self-start mb-0"
                >
                  <span class="m-0 p-0 text-12 text-onyx font-bold w-auto"
                    >Hiring Now</span
                  >
                </vs-chip>
              </span>

              <div class="perks-wrapper w-auto mt-16px flex flex-wrap gap-2">
                <vs-chip
                  v-for="(perk, index) in job['job_perks']"
                  :key="index"
                  :color="perk['color_10']"
                  class="m-0 self-start rounded-6px w-auto md:w-72px"
                  style="min-width: fit-content !important"
                >
                  <span
                    class="m-0 p-0 text-12 text-onyx-lightest font-medium w-auto"
                  >
                    <template
                      v-if="
                        perk.icon_url != '' &&
                        perk.icon_url.toString().length > 1
                      "
                    >
                      <object
                        :data="perk.icon_url"
                        width="12"
                        height="12"
                        class="translate-icon-object"
                      ></object>
                    </template>

                    {{ perk['desc'] }}
                  </span>
                </vs-chip>
                <vs-chip
                  v-if="job['is_hiring_event']"
                  class="m-0 self-start rounded-6px w-auto md:w-72px"
                  style="min-width: fit-content !important"
                >
                  <span
                    class="m-0 p-0 text-12 text-onyx-lightest font-medium w-auto"
                  >
                    Hiring Event
                  </span>
                </vs-chip>
              </div>
            </div>
            <hr
              v-if="showApplyButton"
              class="divider hidden md:block md:border-chrome-lightest md:border-solid -my-6 md:ml-8 md:mr-23px"
            />
            <div v-if="showApplyButton" class="hidden md:block my-auto">
              <a :href="generateLink(job)" :target="generateTarget(job)">
                <primary-button
                  size="large"
                  class="w-full lg:w-187px"
                  title="Apply"
                >
                  Apply
                </primary-button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </a>
    </div>

    <div
      class="w-full mx-auto mt-8 md:mt-10 lg:w-auto flex justify-center"
      @click="loadMoreJobs"
      v-if="isLoadMoreJobs"
    >
      <primary-button
        size="large"
        class="bg-primary text-white text-14"
        title="Expand Search"
      >
        Expand Search
      </primary-button>
    </div>
  </div>
</template>

<script>
import { slugify } from '../../utilities/slugify';

export default {
  name: 'JobsViewMore',

  props: {
    jobs: {
      type: Array,
      required: true,
    },
    applicantId: {
      type: Number,
      default: 0,
    },
    msg: {
      type: Array,
      required: true,
    },
    thankYouPage: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Object,
    }
  },

  data: function () {
    return {
      isLoadMoreJobs: true,
      displayJobs: this.jobs || [],
      nextPageLoaded: false,
      scroll: 0,
      showApplyButton: false,
    };
  },

  created() {
    window.addEventListener('scroll', this.onScroll);
    this.showApplyButtonCalculation();
  },

  methods: {
    loadMoreJobs() {
      window.location = '/jobs?eauth=' + this.applicantId;
    },

    showApplyButtonCalculation() {
      this.showApplyButton = false;
      if (screen.width <= 1024 && screen.width >= 480) {
        this.showApplyButton = true;
      }
    },

    saveRecommendedJobs() {
      let arr = this.jobs;
      let splitSize = 6;

      // split the jobs each with max size of 6
      for (let i = 0; i < arr.length; i += splitSize) {
        const chunk = arr.slice(i, i + splitSize);
        this.recommendedJobs.push(chunk);
      }
    },

    generateLink(job) {
      return job.is_linkout && job.linkout_url ? job.linkout_url : '/jobs/' + job['id'] + '/' + job['company']['slug'] +'-'+ job['slug'];
    },

    generateTarget(job) {
      return job.is_linkout && job.linkout_url ? '_blank' : null;
    },

    redirectToJob(job) {
      if (job.is_linkout && job.linkout_url) {
        window.open(job.linkout_url, '_blank');
        /** for thank you page, open a new tab with the full app url and do not refresh page**/
        if (!this.thankYouPage) {
          window.location.reload();
        }
      }
    },

    slugify(str) {
      return slugify(str);
    },
  },
};
</script>

<style scoped>
.ellipse-two-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
